import styled, { css } from "styled-components";
import { convertInputIdToValues } from "../../Input/StyledInput/StyledInput.methods";
import {
  TInputId,
  TInputReadoutValue,
} from "@ecp-redux/dto/themeSettings/themeSettings.types";
import { convertColorIdToHex } from "@ecp-boxes/settingsPatterns/settingsPatterns.methods";
import composeCss from "@ecp-boxes/settingsPatterns/composeCss";
import { IElementInput } from "@ecp-redux/dto/themeSettings/settingsPatterns.types";

export const InternationalPhoneInputStyled = styled.div<{
  $settings: IElementInput | TInputId | TInputReadoutValue;
  formNoValidate?: boolean;
}>`
  ${({ $settings, theme, formNoValidate }) => {
    const {
      width,
      height,
      border,
      activeBorder,
      background,
      disabledBorder,
      errorBorder,
      floatingLabel,
      font,
      hoverBorder,
      text,
    } = convertInputIdToValues($settings, theme.globalObjects?.inputs);

    const [
      backgroundColor,
      activeBackgroundColor,
      disabledBackgroundColor,
      hoverBackgroundColor,
    ] = [
      background.color,
      background.activeColor,
      background.disabledColor,
      background.hoverColor,
    ].map((color) => convertColorIdToHex(color, theme.colorPalette));

    const [
      borderColor,
      activeBorderColor,
      disabledBorderColor,
      hoverBorderColor,
      errorBorderColor,
    ] = [
      border.color,
      activeBorder.color,
      disabledBorder.color,
      hoverBorder.color,
      errorBorder.color,
    ].map((color) => convertColorIdToHex(color, theme.colorPalette));

    return css`
    .country-list {
      position: fixed;
      z-index: 1000;
      width: fit-content;
    }
    .country-name {
      display: none;
    }
      width: ${width}%;
      height: 100%;
      .selected-flag, .flag-dropdown.open, .selected-flag.open {
        &, &:hover, &:focus, &:active {
          background-color: unset !important;
          border-color: unset !important;
        }
      }
      .react-tel-input {
      height: ${height}px;

        width: 100%;
      }
      .international-phone-input, .flag-dropdown, .flag-dropdown.open {
        border-width: ${border.width.top}px ${border.width.right}px ${border.width.bottom}px ${border.width.left}px;
        border-style: ${border.style};
        border-color: ${borderColor};
        &:hover {
          background-color: ${hoverBackgroundColor} !important;
          border-color: ${hoverBorderColor};
        }
        &:is(:focus, :active) {
          border-color: ${activeBorderColor};
          background-color: ${activeBackgroundColor};
        }
        &:disabled {
          border-color: ${disabledBorderColor};
          background-color: ${disabledBackgroundColor};
        }
        ${composeCss.borderColor(
          formNoValidate === true || formNoValidate === undefined
            ? border.color
            : errorBorder.color,
          theme
        )}
      }

      .flag-dropdown, .flag-dropdown.open {
        border-top-left-radius: ${border.radius}px;
        border-bottom-left-radius: ${border.radius}px;
      }
      .international-phone-input {
        height: 100%;
        width: 100%;
        border-radius: ${border.radius}px;

        ${composeCss.font(font.input, theme.typography)}
        color: ${convertColorIdToHex(text.color, theme.colorPalette)};
        border-width: ${border.width.top}px ${border.width.right}px ${border.width.bottom}px ${border.width.left}px;
        border-style: ${border.style};
        border-radius: ${border.radius}px;
        background-color: ${backgroundColor};
        &::placeholder {
          ${composeCss.font(font.placeholder, theme.typography)}
          color: ${convertColorIdToHex(text.placeholderColor, theme.colorPalette)};
      }
      `;
  }}
`;
